import { Injectable } from '@angular/core';
import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError, finalize } from 'rxjs/operators';
import { HEADER_STATUS_CODE } from "@core/constants";
import { AuthService } from "@core/authentication/auth.service";


@Injectable()
export class ErrorInterceptor implements HttpInterceptor {
  private requestMap = new Map<string, HttpRequest<any>>();

  constructor(
    private authService: AuthService,
  ) {
  }

  private errorPages = [
    HEADER_STATUS_CODE.FORBIDDEN,
    // HEADER_STATUS_CODE.NOT_FOUND,
    HEADER_STATUS_CODE.INTERNAL_SERVER_ERROR
  ];

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    const clonedRequest = request.clone();
    this.requestMap.set(request.urlWithParams, clonedRequest);

    return next.handle(request).pipe(
      catchError((error: HttpErrorResponse) => this.handleError(error)),
      // Final handle remove params
      finalize(() => this.requestMap.delete(request.urlWithParams))
    );
  }

  private handleError(error: HttpErrorResponse) {
    // 1. Kiểm tra mã 401 Unauthorized - Chuẩn mới từ Backend cho API
    // Hoặc mã 302 FOUND (nếu có)
    if (error.status === HEADER_STATUS_CODE.UNAUTHORIZED || error.status === HEADER_STATUS_CODE.FOUND) {
      this.authService.logout();
    }

    // 2. Dự phòng: Kiểm tra trường hợp bị redirect ngầm về trang chủ (/) nếu vẫn còn bị cache hoặc 
    // các API cũ chưa được cập nhật mã 401
    const currentOrigin = window.location.origin + '/';
    if (error.status === 200 || error.status === 0) {
      if (error.url === currentOrigin || error.url === window.location.origin) {
        this.authService.logout();
      }
    }

    return throwError(() => error);
  }

}
